<template>
  <div id="AccessPage" class="bg-brand-secondary">
    <b-spinner v-if="isValidating" class="brand-highlight-1"></b-spinner>
    <div v-else class="d-flex flex-column">
      <p class="error-message">
        Sorry, something went wrong, please try again later.
      </p>
      <b-button
        variant="cta-outline"
        class="mx-auto"
        squared
        size="lg"
        @click="redirectToLogin"
        >Back</b-button
      >
    </div>
  </div>
</template>

<script>

export default {
  name: "AccessPage",
  props: {
    token: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      isValidating: true,
    };
  },
  mounted() {
    if (this.token) {
      this.getAccessToken(this.token);
    } else {
      this.redirectToLogin();
    }
  },
  methods: {
    async getAccessToken(token) {
      try {
        const payload = {
          security_token: token
        };
        const res = await this.$store.dispatch("authenticateWithAccessToken", {
          payload
        });
        if (!res?.success) {
          this.redirectToLogin()
        }
      } catch (err) {
        this.redirectToLogin()
      } finally {
        this.isValidating = false
      }
    },
    redirectToLogin() {
      this.$router.push("/login");
    }
  }
};
</script>

<style lang="less">
#AccessPage {
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: auto;

  .error-message {
    color: white;
    font-size: 2rem;
    padding: 20px;
  }
}
</style>
